import { ErrorHandler, inject, Injectable } from '@angular/core';

import { NewRelicService } from '@services/new-relic.service';
import { SplunkLoggerService } from '@services/splunk-logger.service';
import { ApigeeError } from '@utilities/http-utilities';

@Injectable({ providedIn: 'root' })
export class CustomErrorHandler implements ErrorHandler {
  // Services
  private readonly newRelicService = inject(NewRelicService);
  private readonly splunkLoggerService = inject(SplunkLoggerService);

  // Methods
  handleError(error: unknown): void {
    // Skip New Relic reporting for ApigeeErrors — already reported server-side
    if (error instanceof ApigeeError) return;

    this.newRelicService.noticeError(error);
    this.splunkLoggerService.error(error);
  }
}
